<template>

<div class="first-section-container">
  <v-sheet class="bg-black cards-container">

   <div class="content-wrapper">


    <div class="text-side">

        <div class="cards-title text-left">
        <h1 class="about-title">ABOUT KUHUL </h1>
        </div>

        <div class="about-text">
        <p>
            Ayham is the founder of Kuhul, an independent brewing project based in Belgium.

            With roots in Arab culture and experience in the European craft beer scene, Ayham’s approach to brewing is shaped by both worlds. Kuhul was built to create beers with a clear identity, not just to follow trends, but to stand apart in a crowded market.

            Focusing on hop-forward styles like New England IPAs and Double IPAs, Kuhul emphasizes balance, aroma, and drinkability. Each beer is developed with intention, from the recipe to the name, where references like Falak and Sarāb reflect a deeper cultural influence.

            As Kuhul grows, the focus remains simple: stay independent, keep improving, and brew beers that carry both character and purpose.
        </p>
        </div>

    </div>

    
    <div class="image-side">
        <img height="550" src="/models/ayham.jpg" />
    </div>

    </div>

    <div class="kuhul-scroll">
        <div class="kuhul-track">
            
        
            <div class="kuhul-group">
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            </div>

           
            <div class="kuhul-group">
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            <span>كُحُل</span><span>كُحُل</span><span>كُحُل</span><span>كُحُل</span>
            </div>

        </div>
        </div>

  </v-sheet>
</div>
</template>
  
  
<script>



 
  
export default {
    name: "ThirdSection",
    components : {

    },
    data: () => ({
        componentStep : 1,
    }),
    mounted() {
    },
    methods: {
    },
 };

</script>

<style>

.first-section-container {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
}

.cards-container {
    width: 100%;
    max-width: 1200px;
    
    display: flex;
    flex-direction: column;

  
}


.about-title {
    font-size: 90px;
    text-align: left;
    margin: 0;
    line-height: 0.9;
}

.about-text {
    max-width: 1200px;
    text-align: left;
    margin-top:20px;
    padding-bottom: 20%;
    margin-bottom: 150px;
}

.kuhul-scroll {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    pointer-events: none;
}

.kuhul-track {
    display: flex;
    width: max-content;
    animation: scroll-kuhul 12s linear infinite;
}

.kuhul-group {
    display: flex;
    flex-shrink: 0; 
}

.kuhul-group span {
    font-size: 200px;
    font-weight: bold;
    opacity: 1;
    margin-right: 80px;
    white-space: nowrap;
}

.text-side {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
}


.image-side {
    flex: 1;
    display: flex;
    justify-content: flex-end;
}

.content-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: flex-start; 
    gap: 60px;
    width: 100%;   
}

.image-side {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
}



@keyframes scroll-kuhul {
    from {
        transform: translateX(0%);
    }
    to {
        transform: translateX(-50%);
    }
}


@media (max-width: 960px) {

  .content-wrapper {
    flex-direction: column;
    gap: 30px;
    align-items: center;
  }

  .text-side {
    width: 100%;
    align-items: center;
    text-align: center;
  }

  .about-title {
    font-size: 42px;
    text-align: center;
    line-height: 1.1;
  }

  .about-text {
    font-size: 15px;
    padding: 0 20px 60px;
    margin-bottom: 60px;
    text-align: justify;
  }

  .image-side {
    width: 100%;
    justify-content: center;
  }

  .image-side img {
    width: 80%;
    height: auto;
    max-height: 380px;
    object-fit: cover;
    border-radius: 10px;
  }

  /* scrolling Arabic banner */
  .kuhul-group span {
    font-size: 80px;
    margin-right: 30px;
  }

  .kuhul-scroll {
    position: relative;
    margin-top: 30px;
  }
}

</style>
    